export default __webpack_public_path__ + "static/media/review9.7414e274.jpg";